import { HttpHeaders } from '@angular/common/http';

export function getAuthHeaders(): HttpHeaders {
    return new HttpHeaders({
        'Content-Type': 'application/json',
        //ApiKey: 'T0h7BuCOv1J60kZV?l9DjXmgEI31wFTCLfCZ!xp1',
    });
}

export function getBearerHeaders(accessToken): HttpHeaders {
    return new HttpHeaders({
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
        //ApiKey: 'T0h7BuCOv1J60kZV?l9DjXmgEI31wFTCLfCZ!xp1',
    });
}

export function setBearerHeaders(accessToken): any {
    return {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
        //ApiKey: 'T0h7BuCOv1J60kZV?l9DjXmgEI31wFTCLfCZ!xp1',
    };
}
